import { useEffect } from "react";

export function useInitUserForm() {
  function intlTelInput(script) {
    script.innerHTML = `
      var input = document.querySelector("#phone");
      window.intlTelInput(input, {
        autoHideDialCode: false,
        formatOnDisplay: false,
        utilsScript: "/js/utils.js",
      });
    `;

    script.async = true;

    document.body.appendChild(script);
  }

  useEffect(() => {
    const script = document.createElement("script");

    intlTelInput(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
}

export function profileCompletedPercent(user) {
  const base = ["nickname", "name", "email", "facebook_id", "google_id", "tfa", "avatar", "loyal_member", "phone"];
  const filled = [];

  for (const key of base) {
    if (user[key]) {
      filled.push(key);
    }
  }

  return Math.ceil((filled.length * 100) / base.length);
}
